/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Planner_FailedInputs */

const en_planner_failed = /** @type {(inputs: Planner_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The suggestion didn’t work. Please try again.`)
};

const de_planner_failed = /** @type {(inputs: Planner_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Vorschlag hat nicht geklappt. Versuch es noch einmal.`)
};

/**
* | output |
* | --- |
* | "The suggestion didn’t work. Please try again." |
*
* @param {Planner_FailedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const planner_failed = /** @type {((inputs?: Planner_FailedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planner_FailedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_planner_failed(inputs)
	return en_planner_failed(inputs)
});